import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import globalStyle from 'assets/scss/Global.module.scss'
import SpinnerWidget from 'components/widgets/Spinner/SpinnerWidget'
import { useTranslation } from 'react-i18next'
import styles from './Odin.module.scss'
import { getFileList } from 'store/odin/odin.slice'

const OdinComponent = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { odinFileList, isListLoading } = useSelector((state) => state.odin)

  useEffect(() => {
    dispatch(getFileList())
  }, [dispatch])

  return (
    <SpinnerWidget spinning={isListLoading}>
      <h2 className={globalStyle.pageHeader}>{t('odin.title')}</h2>
      <div className={styles.profile}>
        {odinFileList ? (
          <ul className={styles.tree}>
            {odinFileList.length > 0 &&
              odinFileList.map((node) => (
                <li key={node} className={styles.item}>
                  <a href={`${process.env.REACT_APP_ODIN_URL}/${node}`}>{node}</a>
                </li>
              ))}
          </ul>
        ) : null}
      </div>
    </SpinnerWidget>
  )
}

export default OdinComponent
